import moment from 'moment'
import _ from 'lodash'

export const _Stats = {
  namespaced: true,
  state: {
    'dateStart': {},
    'dateEnd': {},
    'period': 4, // 7 derniers jours
    'agents': [],
    'bots': [],
    'sites': [],
    'motifs': [],
    'majBot': 0
  },
  getters: {
    /**
     * Retourne la liste des paramètres des paramètres en String
     * @return {String} paramètre utilisés pour les requêtes des stats
     */
    params (state) {
      let params = 'dateStart=' + encodeURIComponent(state.dateStart) +
        '&dateEnd=' + encodeURIComponent(state.dateEnd) +
        '&sitesId=' + _.toString(_.map(state.sites, 'LIC_ID')) +
        '&motifsId=' + _.toString(_.map(state.motifs, 'MOT_CODE')) +
        '&agentsId=' + _.toString(_.map(state.agents, 'USR_ID'))
      let botsId = state.bots.map(b => b.USR_ID)
      botsId = []
      if (botsId.length) {
        params += '&botsId=' + _.toString(botsId)
      }
      return params
    },
    tokenParams (state) {
      let params = 'dateStart=' + encodeURIComponent(state.dateStart) +
        '&dateEnd=' + encodeURIComponent(state.dateEnd)
      let botsId = state.bots.map(b => b.USR_ID)
      botsId = []
      if (botsId.length) {
        params += '&botsId=' + _.toString(botsId)
      }
      return params
    },
    GET_DATESTART (state) {
      return state.dateStart
    },
    GET_DATEEND (state) {
      return state.dateEnd
    },
    GET_MAJBOT (state) {
      return state.majBot
    }
  },
  mutations: {
    INIT (state, init) {
      state.dateStart = moment().subtract(7, 'day').hours(23).minutes(59).seconds(59).format()
      state.dateEnd = moment().startOf('day').hours(0).minutes(0).seconds(0).format()
      state.period = 4
      state.agents = []
      state.bots = []
      state.sites = []
      state.motifs = []
    },
    /**
     * Défini la date de début
     * @param {Date} dateStart nouvelle date de début
     */
    SET_DATE_START (state, dateStart) {
      state.dateStart = dateStart
    },
    /**
     * Défini la date de fin
     * @param {Date} dateEnd nouvelle date de fin
     */
    SET_DATE_END (state, dateEnd) {
      state.dateEnd = dateEnd
    },
    /**
     * Défini la période des stats
     * @param {Number} period nouvelle période d'étude
     */
    SET_PERIOD (state, period) {
      state.period = period
    },
    /**
     * Défini les agents associés
     * @param {Array} agents Tableau d'agents
     */
    SET_AGENTS (state, agents) {
      state.agents = agents
    },
    /**
     * Défini les bots associés
     * @param {Array} agents Tableau d'bots
     */
    SET_BOTS (state, bots) {
      state.bots = bots
    },
    /**
     * Défini les sites associés
     * @param {Array} sites Tableau de sites
     */
    SET_SITES (state, sites) {
      state.sites = sites
    },
    /**
     * Défini les motifs associés
     * @param {Array} motifs Tableau de motifs
     */
    SET_MOTIFS (state, motifs) {
      state.motifs = motifs
    },
    /**
     * Défini le nombre de mise à jour du bot
     * @param {Number} maj nombre de maj
     */
    SET_MAJBOT (state, maj) {
      state.majBot = maj
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/stats.js